export default __webpack_public_path__ + "static/media/Delete-All.2e382403.svg";